import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { ResolutionProvider, useResolution } from '../../contexts/ResolutionContext';

// Component imports
import ProfileHeader from './ProfileHeader';
import ClaimAccountSection from './ClaimAccountSection';
import ResolutionDashboard from '../Resolution/ResolutionDashboard';
import NotificationToast from '../Common/NotificationToast';
import LoadingOverlay from '../Common/LoadingOverlay';

// Modal imports
import AddResolutionModal from '../Modals/AddResolutionModal';
import DecryptModal from '../Modals/DecryptModal';
import { useLanguage } from '../../contexts/LanguageContext';

// Main Person component wrapper
function PersonContent() {
	const navigate = useNavigate();
	const { currentUser, logout } = useAuth();
	const { decryptResolution } = useResolution();
	const { t } = useLanguage();

	// Modal state (kept local as it's UI-specific)
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isDecryptModalOpen, setIsDecryptModalOpen] = useState(false);
	const [selectedResolutionId, setSelectedResolutionId] = useState(null);

	const handleDecryptResolution = (resolutionId) => {
		setSelectedResolutionId(resolutionId);
		setIsDecryptModalOpen(true);
	};

	const handleDecrypt = async (resolutionId, decryptKey) => {
		const success = await decryptResolution(resolutionId, decryptKey, t);
		if (success) {
			setIsDecryptModalOpen(false);
		}
		return success;
	};

	const handleLogout = async () => {
		try {
			await logout();
			navigate('/');
		} catch (error) {
			console.error('Logout failed:', error);
		}
	};

	return (
		<div className='container mx-auto mt-8 p-4'>
			{/* Notification Toast */}
			<NotificationToast />

			{/* Loading Overlay */}
			<LoadingOverlay />

			{/* Profile Header */}
			<ProfileHeader onLogout={handleLogout} onOpenAddModal={() => setIsModalOpen(true)} />

			{/* Claim Account Section (if needed) */}
			<ClaimAccountSection />

			{/* Main Resolution Dashboard */}
			<ResolutionDashboard onDecryptResolution={handleDecryptResolution} />

			{/* Add Resolution Modal */}
			<AddResolutionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

			{/* Decrypt Modal */}
			<DecryptModal
				isOpen={isDecryptModalOpen}
				onClose={() => setIsDecryptModalOpen(false)}
				onDecrypt={handleDecrypt}
				resolutionId={selectedResolutionId}
			/>
		</div>
	);
}

// Main exported component with context provider
export default function Person() {
	const { personId } = useParams();

	console.log('PersonWithContext received personId:', personId);

	return (
		<ResolutionProvider personId={personId}>
			<PersonContent />
		</ResolutionProvider>
	);
}
